import { Component, createSignal, Index, Show } from 'solid-js';
import { ContextMenuItemConfig, DataItem, MetaDataConfig } from './interfaces';
import DataGroupSectionItem from './DataGroupSectionItem';

export interface DataGroupSectionProps {
  dataGroupName: string;
  dataGroupLength: number;
  initialExpanded: boolean;
  dataItems: DataItem[];
  metaData: MetaDataConfig;
  contextMenuItems?: ContextMenuItemConfig[];
  handleDataVisibility(
    dataType: string,
    dataId: string,
    visible: boolean
  ): void;
}

const DataGroupSection: Component<DataGroupSectionProps> = (props) => {
  const [isExpanded, setIsExpanded] = createSignal(props.initialExpanded);

  const toggleExpanded = (): boolean => {
    return setIsExpanded(!isExpanded());
  };

  // /* Disable for Q2 */
  // const allToggled = createMemo(
  //   () => items.length > 0 && items.every((item) => item['visible'])
  // );

  /**
   * Handles the "Toggle All / Untoggle All" functionality.
   */
  // /* Disable for Q2 */
  // const handleToggleAll = (): void => {
  //   const targetState = !allToggled();
  //   setItems(() => true, 'visible', targetState);
  // };

  return (
    <div>
      <modus-wc-menu
        orientation="vertical"
        custom-class="overflow-auto m-0 pb-0"
      >
        <li>
          <div class="flex flex-row items-center justify-start">
            <modus-icon
              color="#555"
              name={isExpanded() ? 'caret_down' : 'caret_right'}
              onClick={toggleExpanded}
            />
            {/* Disable for Q2 */}
            {/* <modus-icon
              color="#555"
              name={allToggled() ? 'visibility_on' : 'visibility_off'}
              onClick={handleToggleAll}
            /> */}
            <div class="font-bold pb-1 cursor-default">
              {props.dataGroupName} ({props.dataGroupLength})
            </div>
          </div>
        </li>
        <Show when={isExpanded() && props.dataItems.length > 0}>
          <div class="flex flex-col">
            <Index each={props.dataItems}>
              {(file) => (
                <li>
                  <DataGroupSectionItem
                    id={String(file()[props.metaData.id])}
                    dataItem={file()}
                    metadata={props.metaData}
                    visible={file().visible ?? false}
                    loading={file().loading ?? false}
                    deleting={file().deleting ?? false}
                    contextMenuItems={props.contextMenuItems ?? []}
                    onItemVisibilityChange={props.handleDataVisibility}
                  />
                </li>
              )}
            </Index>
          </div>
        </Show>
      </modus-wc-menu>
    </div>
  );
};

export default DataGroupSection;
